export default "__VITE_ASSET__DyHaBqU3__"